import React from 'react';
import './ProductsHero.css';

export default function ProductsHero() {
  return (
    <section className="ph">
      <div className="ph__inner">
        
        {/* LEFT: Branding & Narrative */}
        <div className="ph__content">
          <p className="ph__eyebrow">A r c h i v e &nbsp; / &nbsp; 2 0 2 6</p>
          <h1 className="ph__title">
            <span>THE</span>
            <span className="ph__title-red">DROP</span>
          </h1>
          <div className="ph__body-wrap">
            <p className="ph__body">
              Please be advised: this product is a AAA-grade replica. 
              It is manufactured to high-quality standards to provide a similar aesthetic and feel to the original, 
              but it is not an original brand-name product.
            </p>
          </div>
        </div>

        {/* RIGHT: Editorial Visuals (No Stats) */}
        <div className="ph__visual">
          <div className="ph__badge">
            <span className="ph__badge-text">EST. 2019</span>
            <div className="ph__badge-line"></div>
            <span className="ph__badge-text">DURBAN, SA</span>
          </div>
          
          <div className="ph__editorial-text">
            <span className="ph__ghost-text">ORIGINAL</span>
            <span className="ph__ghost-text">RETRO</span>
            <span className="ph__ghost-text">LIMITED</span>
          </div>
        </div>

      </div>

      {/* Clean separation line */}
      <div className="ph__divider">
        <div className="ph__divider-inner"></div>
      </div>
    </section>
  );
}